<script lang="ts">
  import type { User } from "$types";
  import { lazyLoad } from "$lib/actions/lazyLoad";

  export let user: User | string;
  export let shimmer: boolean = true;
  export let hoverable: boolean = false;
  export let active: boolean = false;

  const BACKEND_URL = "https://backend.craftroulette.live";

  let first_initial =
    typeof user === "string" ? "C" : (user.first_name?.charAt(0) ?? "C");
  let last_initial =
    typeof user === "string" ? "R" : (user.last_name?.charAt(0) ?? "R");

  // use this to dynamically calculate the font size
  let width: number;
  let avatar_url: string;

  // typescript type narrowing to figure out if user.avatar is an object or a string
  $: if (typeof user === "string") {
    avatar_url = "";
  } else if (user?.avatar && typeof user.avatar === "string") {
    avatar_url = `${BACKEND_URL}/assets/${user.avatar}?key=avatar`;
  } else if (typeof user?.avatar !== "string" && user?.avatar?.id) {
    avatar_url = `${BACKEND_URL}/assets/${user.avatar?.id}?key=avatar`;
  }
</script>

{#if user}
  <div
    class="avatar"
    class:active
    bind:clientWidth={width}
    class:hoverable
    style:font-size="{width / 2.4}px"
    style:border="{width * 0.05 > 4 ? width * 0.05 : 4}px solid white"
    style:padding-top="{width < 100 ? 4 : 0}%"
    class:initials={typeof user === "string" || !user.avatar}
  >
    {#key user}
      {#if shimmer}
        <div class="avatar_overlay shimmer" />
      {/if}
      {#if typeof user !== "string" && user.avatar}
        <img
          use:lazyLoad={avatar_url}
          src="/pixel.png"
          alt="{user.first_name} {user.last_name}'s avatar"
        />
      {:else}
        {first_initial}{last_initial}
      {/if}
    {/key}
  </div>
{/if}

<style>
.avatar {
  width: 100%;
  height: 100%;
  aspect-ratio: 1/1;
  position: relative;
  display: grid;
  place-content: center;
  background: var(--secondary);
  border-radius: 50%;
  font-weight: bold;
  color: white;
  font-family: "Open Sans", sans-serif;
  overflow: hidden;
  line-height: 1;
  box-shadow: var(--shadow);
  z-index: 1;
  text-transform: uppercase;
}
.avatar.hoverable {
  transition: all 200ms ease;
}
.avatar.hoverable:hover {
  border-color: var(--secondary) !important;
}
.avatar.active {
  transition: all 200ms ease;
  border-color: var(--secondary) !important;
}

img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.avatar_overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
}

@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
</style>
